The opaque cursor to the hirer.

This can be used as a subsequent pagination argument.
